<style lang="scss" scoped>
select.form-control,
input.form-control {
  height: 34px;
  border: 1.5px solid #dde2ec;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 13px;
  color: #0d1b3e;
  background: #fff;
  outline: none;
  font-family: 'Segoe UI', sans-serif;
  transition: border-color 0.2s;
  width: 100%;
  box-shadow: none;

  &:focus {
    border-color: #389ad4;
    box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
  }
}

select.form-control {
  padding: 0 28px 0 10px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
  appearance: none;
  cursor: pointer;
}

.form-group label {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
  display: block;
  font-family: 'Segoe UI', sans-serif;
}

.btn-search-adv {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 16px;
  border-radius: 7px;
  border: none;
  background: #389ad4;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, box-shadow 0.15s;

  i { font-size: 12px; }

  &:hover {
    background: #2d85bb;
    box-shadow: 0 4px 12px rgba(56, 154, 212, 0.35);
  }

  &:active {
    background: #246fa0;
  }
}

/* ── Type-and-select ── */
.ts-wrap {
  position: relative;
  margin-bottom: 0;
}

.ts-input {
  display: flex;
  align-items: center;
  height: 34px;
  border: 1.5px solid #dde2ec;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  cursor: pointer;
  gap: 6px;
  transition: border-color 0.2s;

  &:hover { border-color: #389ad4; }
  &:focus-within {
    border-color: #389ad4;
    box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
  }
}

.ts-val {
  flex: 1;
  font-size: 13px;
  color: #0d1b3e;
  font-family: 'Segoe UI', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.ts-search {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  color: #0d1b3e;
  font-family: 'Segoe UI', sans-serif;
  background: transparent;
  min-width: 0;

  &::placeholder { color: #b0bac9; }
}

.ts-arrow {
  font-size: 10px;
  color: #a0aab8;
  flex-shrink: 0;
  transition: transform 0.2s;
  pointer-events: none;

  &.open { transform: rotate(180deg); }
}

.ts-dropdown {
  position: fixed;
  background: #fff;
  border: 1.5px solid #dde2ec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
  z-index: 9999;
  max-height: 210px;
  overflow-y: auto;
}

.ts-item {
  padding: 8px 12px;
  font-size: 13px;
  color: #0d1b3e;
  font-family: 'Segoe UI', sans-serif;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  transition: background 0.12s;

  &:hover { background: #f0f7fd; color: #389ad4; }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
  font-family: 'Segoe UI', sans-serif;
}

.btn-export-adv {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 7px;
  border: 1.5px solid #276749;
  background: transparent;
  color: #276749;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  transition: background 0.15s;

  i { font-size: 12px; }

  &:hover {
    background: #f0faf4;
    color: #276749;
    text-decoration: none;
  }

  &:active {
    background: #d0f0de;
  }
}
</style>
<template>
  <div class="row search">
   
    <div class="col-md-12 col-sm-12 row" v-if="is_job_report">
      <div class="col-md-2 col-sm-2">
        <div class="form-group">
          <label for=""> Search</label>
          <input
            type="text"
            v-model="search.search_text"
            class="form-control"
            placeholder="Search with job title"
            name=""
            id=""
            @keypress.enter="SearchText()"
          />
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn-search-adv" @click="SearchText()" style="margin-top: 25px">
          <i class="fa fa-search"></i> Search
        </button>
      </div>
    </div>
    
    <div class="col-md-12 col-sm-12 row">
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_admin_sp_company">
        <div class="form-group ts-wrap" ref="spCmpWrap" v-click-outside="closeSpCmpDropdown">
          <div class="ts-input" @click="toggleSpCmp">
            <span class="ts-val" v-if="!spCmpOpen">{{ spCmpLabel }}</span>
            <input v-if="spCmpOpen" type="text" class="ts-search" v-model="spCmpSearch"
              placeholder="Search provider…" ref="spCmpInput" @keydown.esc="closeSpCmpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: spCmpOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="spCmpOpen" :style="spCmpDropStyle">
            <div class="ts-item" @click="selectSpCmp('all')">All Service Providers</div>
            <div class="ts-item" v-for="(c, i) in filteredSpCmp" :key="i" @click="selectSpCmp(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredSpCmp.length === 0 && spCmpSearch">No match</div>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_company && !is_admin_sp_location">
        <div class="form-group ts-wrap" ref="cmpWrap" v-click-outside="closeCmpDropdown">
          <div class="ts-input" @click="toggleCmp">
            <span class="ts-val" v-if="!cmpOpen">{{ cmpLabel }}</span>
            <input v-if="cmpOpen" type="text" class="ts-search" v-model="cmpSearch"
              placeholder="Search company…" ref="cmpInput" @keydown.esc="closeCmpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: cmpOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="cmpOpen" :style="cmpDropStyle">
            <div class="ts-item" @click="selectCmp('all')">All Companies</div>
            <div class="ts-item" v-for="(c, i) in filteredCmp" :key="i" @click="selectCmp(c.id)">{{ c.company_name }}</div>
            <div class="ts-empty" v-if="filteredCmp.length === 0 && cmpSearch">No match</div>
          </div>
        </div>
      </div>
  
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_admin_sp">
        <div class="form-group ts-wrap" ref="spWrap" v-click-outside="closeSpDropdown">
          <div class="ts-input" @click="toggleSp">
            <span class="ts-val" v-if="!spOpen">{{ spLabel }}</span>
            <input v-if="spOpen" type="text" class="ts-search" v-model="spSearch"
              placeholder="Search provider…" ref="spInput" @keydown.esc="closeSpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: spOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="spOpen" :style="spDropStyle">
            <div class="ts-item" @click="selectSp('all')">All Service Providers</div>
            <div class="ts-item" v-for="(c, i) in filteredSp" :key="i" @click="selectSp(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredSp.length === 0 && spSearch">No match</div>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_admin_sp_location">
        <div class="form-group ts-wrap" ref="locWrap" v-click-outside="closeLocDropdown">
          <div class="ts-input" @click="toggleLoc">
            <span class="ts-val" v-if="!locOpen">{{ locLabel }}</span>
            <input v-if="locOpen" type="text" class="ts-search" v-model="locSearch"
              placeholder="Search location…" ref="locInput" @keydown.esc="closeLocDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: locOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="locOpen" :style="locDropStyle">
            <div class="ts-item" @click="selectLoc('all')">All Locations</div>
            <div class="ts-item" v-for="(c, i) in filteredLoc" :key="i" @click="selectLoc(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredLoc.length === 0 && locSearch">No match</div>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_company && is_admin_sp_location">
        <div class="form-group ts-wrap" ref="cmpWrap2" v-click-outside="closeCmpDropdown">
          <div class="ts-input" @click="toggleCmp">
            <span class="ts-val" v-if="!cmpOpen">{{ cmpLabel }}</span>
            <input v-if="cmpOpen" type="text" class="ts-search" v-model="cmpSearch"
              placeholder="Search company…" ref="cmpInput2" @keydown.esc="closeCmpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: cmpOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="cmpOpen" :style="cmpDropStyle">
            <div class="ts-item" @click="selectCmp('all')">All Companies</div>
            <div class="ts-item" v-for="(c, i) in filteredCmp" :key="i" @click="selectCmp(c.id)">{{ c.company_name }}</div>
            <div class="ts-empty" v-if="filteredCmp.length === 0 && cmpSearch">No match</div>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_location && !is_job_report">
        <div class="form-group ts-wrap" ref="locIsWrap" v-click-outside="closeLocIsDropdown">
          <div class="ts-input" @click="toggleLocIs">
            <span class="ts-val" v-if="!locIsOpen">{{ locIsLabel }}</span>
            <input v-if="locIsOpen" type="text" class="ts-search" v-model="locIsSearch"
              :placeholder="currentUser.u.is_admin ? 'Search provider…' : 'Search location…'"
              ref="locIsInput" @keydown.esc="closeLocIsDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: locIsOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="locIsOpen" :style="locIsDropStyle">
            <div class="ts-item" @click="selectLocIs('all')">
              {{ currentUser.u.is_admin ? 'All Service Providers' : 'All Locations' }}
            </div>
            <div class="ts-item" v-for="(c, i) in filteredLocIs" :key="i" @click="selectLocIs(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredLocIs.length === 0 && locIsSearch">No match</div>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-2 pr-0" v-if="is_location && is_job_report">
        <div class="form-group">
          <select
            @change="loadServices()"
            name=""
            class="form-control"
            id=""
            v-model="search.location"
          >
            <option value="all">All Location</option>
            <option
              v-for="(citem, index) in getClients"
              v-show="citem.is_mobile_fingerprinting"
              :key="index"
              :value="citem.id"
            >
              {{ citem?.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 pr-0" v-if="is_company1">
        <div class="form-group">
          <select v-model="search.company" name="" class="form-control" id="">
            <option value="all">All Company</option>
            <option
              v-for="(citem, index) in getMasterCompanies"
              :key="index"
              :value="citem.id"
            >
              {{ citem.company_name }}
            </option>
          </select>
        </div>
      </div>

      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="is_date_range && !is_archival"
      >
        <div class="form-group">
          <input
            type="date"
            v-model="search.date_from"
            class="form-control"
            name=""
            id=""
          />
        </div>
      </div>

      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="is_date_range && !is_archival"
      >
        <div class="form-group">
          <input
            type="date"
            v-model="search.date_to"
            class="form-control"
            name=""
            id=""
          />
        </div>
      </div>



      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="is_service_code"
      >
        <div class="form-group">
          <select v-model="search.service_type" name="" class="form-control" id="">
            <option value="all" >All Service Type</option>
            <option
              v-for="(citem, index) in getServiceCodes"
              :key="index"
              :value="citem.code"
            >
              {{ citem?.service_name }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="is_service && is_admin_sp_location"
      >
        <div class="form-group">
          <select v-model="search.service" name="" class="form-control" id="">
            <option value="all">All Service</option>
            <option
              v-for="(citem, index) in getCurrentServices"
              :key="index"
              :value="citem.id"
            >
              {{ citem?.name }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="is_service && !currentUser.u.is_admin && !is_service_report"
      >
     
        <div class="form-group">
          <select v-model="search.service" name="" class="form-control" id="">
            <option value="all">All Service</option>
            <option
              v-for="(citem, index) in getCurrentServices"
              :key="index"
              :value="citem.id"
            >
              {{ citem?.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 pl-2 pr-0" v-if="is_archival">
        <div class="form-group">
          <input
            type="number"
            class="form-control"
            placeholder="No of days"
            aria-describedby="basic-addon2"
            v-model="search.no_of_days"
          />
          <span>Expires in (Days)</span>
        </div>
      </div>
      <div class="col-md-1 pl-2 pr-0" v-if="is_location_enrollment">
        <div class="form-group">
          <select v-model="search.transmit_status" class="form-control">
            <option value="all">All Status</option>
            <option value="000">Draft</option>
            <option value="100">Ready To Transmit</option>
            <option value="200">Transmitted/Completed</option>
            <!-- <option value="Refund">Refunded</option> -->
          </select>
        </div>
      </div>

      <div
        class="col-md-1 col-sm-1 pl-2 pr-0"
        v-if="is_status && !is_location_enrollment"
      >
        <div class="form-group">
          <select
            v-model="search.service_status"
            name=""
            class="form-control"
            id=""
          >
            <option value="all">All Status</option>
            <option value="P">Pending</option>
            <option value="C">Completed</option>
            <option value="U">No-Show</option>
            <option value="Cancel">Canceled</option>
            <!-- <option value="Refund">Refunded</option> -->
          </select>
        </div>
      </div>

      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="
          is_payment_status &&
          !is_location_enrollment &&
          !is_location_appointment
        "
      >
        <div class="form-group">
          <select
            v-model="search.payment_status"
            name=""
            class="form-control"
            id=""
          >
            <option value="all">All Payment Status</option>
            <option value="P">Paid</option>
            <option value="U">Unpaid</option>
          </select>
        </div>
      </div>
      <div
        class="col-md-2 col-sm-2 pl-2 pr-0"
        v-if="has_rating">
        <div class="form-group">
          <select
            v-model="search.ratings"
            name=""
            class="form-control"
            id=""
          >
            <option value="all" selected>All Ratings</option>
            <option value="1">1 Star</option>
            <option value="2">2 Star</option>
            <option value="3">3 Star</option>
            <option value="4">4 Star</option>
            <option value="5">5 Star</option>
          </select>
        </div>
      </div>

      <div
        :class="export_inline ? 'col-md-2 col-sm-2' : 'col-md-1 col-sm-1'"
        class="adv_seach_icon"
        :style="export_inline
          ? 'display:flex; flex-direction:row; align-items:flex-start; gap:6px; flex-wrap:wrap;'
          : 'display:flex; flex-direction:column; align-items:flex-start; gap:4px;'"
      >
        <button class="btn-search-adv" id="btn-search" @click="advSearch()">
          <i class="fa fa-search"></i> Search
        </button>
        <download-excel
          v-if="reportData.length > 1"
          class="btn-export-adv"
          :data="this.reportData"
          :worksheet="this.titleworksheet"
          :fields="this.json_fields"
          :header="this.header"
          type="xls"
          :name="this.report_name"
        >
          <i class="fa fa-download"></i> Export
        </download-excel>
      </div>
    </div>
    <!-- <div
      style="margin-left: -2rem !important;"
      class="col-md-1 col-sm-1"
      v-if="reportData.length > 0"
    >
      <download-excel
        class="btn btn-outline-primary ml-1"
        :data="this.reportData"
        :worksheet="this.titleworksheet"
        :fields="this.json_fields"
        type="xls"
        name="company-report.xls"
      >
        <i class="test-white fa fa-download"></i>
      </download-excel>
    </div> -->
    <div class="col-md-12 col-sm-12 row" v-if="is_bread_crumb">
      <nav aria-label="breadcrumb" class="ml-3">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" v-if="is_company">
            <a>{{ company.company_name }}</a>
          </li>
          <li class="breadcrumb-item" v-if="is_location">
            <a>{{ location?.name }}</a>
          </li>
          <li class="breadcrumb-item" v-if="is_date_range">
            <a
              >{{ bread_crumb_search.date_from }} -
              {{ bread_crumb_search.date_to }}</a
            >
          </li>
          <li class="breadcrumb-item" aria-current="page" v-if="is_service">
            {{ service?.name }}
          </li>
          <li class="breadcrumb-item" aria-current="page" v-if="is_status">
            {{ bread_crumb_search.service_status | filterstatus }}
          </li>
          <li
            class="breadcrumb-item"
            aria-current="page"
            v-if="is_payment_status"
          >
            {{ bread_crumb_search.payment_status | filterPayment }}
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>
<script>
import { FETCH_SERVICES,FETCH_SERVICES_CLIENTS,FETCH_MASTER_COMPANIES } from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";
import JsonExcel from "vue-json-excel";
// import { EXPORT_DATA } from "@/core/services/store/actions.type";

export default {
  components: {
    "download-excel": JsonExcel,
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  computed: {
    filteredSp() {
      const q = (this.spSearch || "").toLowerCase();
      if (!q) return this.getClients || [];
      return (this.getClients || []).filter(c => c.name && c.name.toLowerCase().includes(q));
    },
    filteredLocIs() {
      const q = (this.locIsSearch || "").toLowerCase();
      const list = this.getClients || [];
      return q ? list.filter(c => c.name && c.name.toLowerCase().includes(q)) : list;
    },
    locIsLabel() {
      if (this.search.location === "all") {
        return this.currentUser.u.is_admin ? "All Service Providers" : "All Locations";
      }
      const c = (this.getClients || []).find(c => c.id === this.search.location);
      return c ? c.name : (this.currentUser.u.is_admin ? "All Service Providers" : "All Locations");
    },
    filteredSpCmp() {
      const q = (this.spCmpSearch || "").toLowerCase();
      const list = this.getClients || [];
      return q ? list.filter(c => c.name && c.name.toLowerCase().includes(q)) : list;
    },
    spCmpLabel() {
      if (this.search.sp === "all") return "All Service Providers";
      const c = (this.getClients || []).find(c => c.id === this.search.sp);
      return c ? c.name : "All Service Providers";
    },
    filteredCmp() {
      const q = (this.cmpSearch || "").toLowerCase();
      const list = this.getMasterCompanies || [];
      return q ? list.filter(c => c.company_name && c.company_name.toLowerCase().includes(q)) : list;
    },
    cmpLabel() {
      if (this.search.company === "all") return "All Companies";
      const c = (this.getMasterCompanies || []).find(c => c.id === this.search.company);
      return c ? c.company_name : "All Companies";
    },
    filteredLoc() {
      const q = (this.locSearch || "").toLowerCase();
      const list = this.getSpClients || [];
      if (!q) return list;
      return list.filter(c => c.name && c.name.toLowerCase().includes(q));
    },
    spLabel() {
      if (this.search.sp === "all") return "All Service Providers";
      const c = (this.getClients || []).find(c => c.id === this.search.sp);
      return c ? c.name : "All Service Providers";
    },
    locLabel() {
      if (this.search.sp_location === "all") return "All Locations";
      const c = (this.getSpClients || []).find(c => c.id === this.search.sp_location);
      return c ? c.name : "All Locations";
    },
    getCurrentServices() {
      var services = this.getServices;
      // if (this.$route?.name != "report.location.wise.report") {
      //   var services = this.getServices;
      // } else {
      //   services = this.getServices.filter((item) => {
      //     return item.enable_ori_rate == false;
      //   });
      // }

      return services;
    },
    ...mapGetters([
      "currentUser",
      "getClients",
      "getSpClients",
      "getServices",
      "getMasterCompanies",
      "getSearchDate",
      "getServiceCodes"
    ]),
  },
  filters: {
    filterstatus: function (status) {
      if (status == "P") {
        return "Pending";
      }
      if (status == "C") {
        return "Complete";
      }
      if (status == "U") {
        return "No-show";
      }
      if (status == "Cancel") {
        return "Canceled";
      }
      if (status == "all") {
        return "All";
      }
    },
    filterPayment: function (status) {
      if (status == "P") {
        return "Paid";
      }
      if (status == "U") {
        return "Unpaid";
      }
      if (status == "all") {
        return "All";
      }
    },
  },
  data() {
    return {
      spOpen: false,
      spSearch: "",
      spDropStyle: {},
      locOpen: false,
      locSearch: "",
      locDropStyle: {},
      locIsOpen: false,
      locIsSearch: "",
      locIsDropStyle: {},
      spCmpOpen: false,
      spCmpSearch: "",
      spCmpDropStyle: {},
      cmpOpen: false,
      cmpSearch: "",
      cmpDropStyle: {},
      search: {
        service: "all",
        company: "all",
        date_from: "",
        date_to: "",
        service_status: "all",
        payment_status: "all",
        location: "all",
        search_text: "",
        no_of_days: "30",
        transmit_status: "all",
        sp_location:"all",
        sp:"all",
        service_type:"all",
        ratings:"all"
      },

      company: {
        company_name: "All",
      },
      service: {
        name: "All",
      },
      location: {
        name: "All ",
      },
      companyreportname: "All",
      servicereportname: "All",
      locationreportname: "All",
      locationjobname: "",
      bread_crumb_search: {
        service: "all",
        company: "all",
        date_from: "",
        search_text: "",
        date_to: "",
        service_status: "all",
        payment_status: "all",
        location: "all",
        transmit_status: "all",
        ratings:"all"
      
        
      },
    };
  },
  props: {
    is_company: {
      type: Boolean,
      default: false,
    },
    is_company1: {
      type: Boolean,
      default: false,
    },
    is_location: {
      type: Boolean,
      default: false,
    },
    is_job_report: {
      type: Boolean,
      default: false,
    },
    is_date_range: {
      type: Boolean,
      default: false,
    },
    is_service: {
      type: Boolean,
      default: false,
    },
    is_status: {
      type: Boolean,
      default: false,
    },
    is_payment_status: {
      type: Boolean,
      default: false,
    },
    is_bread_crumb: {
      type: Boolean,
      default: false,
    },
    is_archival: {
      type: Boolean,
      default: false,
    },
    is_service_code:{
      type:Boolean,
      default:false
    },
    export_inline: {
      type: Boolean,
      default: false,
    },
    reportData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    is_service_report: {
      type: Boolean,
      default: false,
    },
    report_name: {
      type: String,
      default: "",
    },
    titleworksheet: {
      type: String,
      default: "",
    },
    is_location_appointment: {
      type: Boolean,
      default: false,
    },
    is_location_enrollment: {
      type: Boolean,
      default: false,
    },
    json_fields: {
      type: Object,
      default: function () {
        return [];
      },
    },
    is_admin_sp_location:{
      type:Boolean,
      default:false,
    },
    is_admin_sp:{
      type:Boolean,
      default:false,
    },
    is_admin_sp_company:{
      type:Boolean,
      default:false,
    },
    is_default_tramist_status:{
      type:String,
      default:'all'
    },
    has_rating:{
      type:Boolean,
      default:false
    }
  },
  mounted() {
    // console.log(this.getSearchDate)
    if (this.getSearchDate == null) {
      this.search = {
        service: "all",
        company: "all",
        date_from: "",
        date_to: "",
        search_text: "",
        service_status: "all",
        payment_status: "all",
        location: "all",
        transmit_status: "all",
        sp_location:"all",
        sp:"all",
        service_type:"all",
        ratings:"all"
      };
      this.search.no_of_days = "30";
      this.search.date_from = this.$moment(new Date())
        .add(-7, "days")
        .format("YYYY-MM-DD");
      this.search.date_to = this.$moment(new Date()).format("YYYY-MM-DD");
    } else {
      this.search = { ...this.getSearchDate };
      this.search.company = "all";
      this.search.no_of_days = "30";
      this.search.location = "all";
      // this.search.sp_location = "all";
      // this.search.sp = "all";

      if(this.currentUser.u.is_admin == 0){
        this.search.sp = this.currentUser.c.id;
        this.search.sp_location = "all";
        this.$store.dispatch(FETCH_SERVICES_CLIENTS, this.search.sp);
      }

      this.search.transmit_status = "all";
      this.search.date_from = this.$moment(this.search.date_from).format(
        "YYYY-MM-DD"
      );
      this.search.date_to = this.$moment(this.search.date_to).format(
        "YYYY-MM-DD"
      );
    }

    if(this.is_default_tramist_status){
      this.search.transmit_status=this.is_default_tramist_status
    }
    // this.advSearch();
  },

  methods: {
    SearchText() {
      if (this.search.search_text == "") {
        this.advSearch();
      } else {
        this.setbreadcrumb();
        this.bread_crumb_search = { ...this.search };
        let header = [];
        if (this.is_job_report && this.search.search_text != "") {
          header.push("Job Report for Job Title: " + this.locationjobname);
        }
        let footer = [];
        footer.push(
          "Generated at : " +
            this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
        );
        footer.push("Generated by : " + this.currentUser.u?.name);
        var search_list = {
          service: "all",
          company: "all",
          date_from: this.$moment(this.search.date_from).format("YYYY-MM-DD"),
          date_to: (this.search.date_to = this.$moment(
            this.search.date_to
          ).format("YYYY-MM-DD")),
          search_text: this.search.search_text,
          service_status: "all",
          payment_status: "all",
          transmit_status: "all",
          location: "all",
          sp: "all",
          sp_location: "all",
          ratings:"all",

        };
        this.search.date_from = this.$moment(this.search.date_from).format(
          "YYYY-MM-DD"
        );
        this.search.date_to = this.$moment(this.search.date_to).format(
          "YYYY-MM-DD"
        );
        let data = {
          header: header,
          search: search_list,
          footer: footer,
        };
        // this.$store.dispatch(EXPORT_DATA, this.search);

        this.$emit("search", data);
      }
    },
    advSearch() {
      this.setbreadcrumb();
      this.search.search_text = "";
      this.bread_crumb_search = { ...this.search };

      let { date_from, date_to, service_status, payment_status } = this.search;
      let header = [];
      if (this.is_job_report && !this.currentUser.u.is_admin) {
        header.push("Job Report for Job: All");
      }
      if (this.is_location && this.is_job_report) {
        header.push("Job Report for Location: " + this.locationreportname);
      }
      if (
        this.is_location &&
        !this.is_job_report &&
        !this.is_archival &&
        !this.currentUser.u.is_admin
      ) {
        header.push("Location: " + this.locationreportname);
      } else if (this.currentUser.u.is_admin) {
        if (this.is_location_enrollment || this.is_location_appointment) {
          header.push("Report for: " + this.locationreportname);
        } else {
          header.push("Service provider : " + this.locationreportname);
        }
      }
      // if(this.is_admin_sp_location||this.is_admin_sp_company){
      //   header.push("Service provider : " + this.locationreportname);
      // }
      if (this.is_archival && this.is_location) {
        header.push("Archival Report for: " + this.locationreportname);
      }
      if (this.is_company) {
        header.push("Company Report for: " + this.companyreportname);
      }
      if (!this.is_archival) {
        header.push(" Date : " + date_from + " - " + date_to);
      }
      let header_combine = [];
      if (
        this.is_service &&
        !this.currentUser.u.is_admin &&
        !this.is_service_report
      ) {
        header_combine.push("Service: " + this.servicereportname);
      }
      if (
        this.is_status &&
        this.currentUser.u.is_admin &&
        this.is_location_appointment
      ) {
        header_combine.push(
          " Service status: " + this.filterstatus(service_status)
        );
      }
      if (this.is_status && !this.currentUser.u.is_admin) {
        header_combine.push(
          " Service status: " + this.filterstatus(service_status)
        );
      }
      if (this.currentUser.u.is_admin && this.is_location_enrollment) {
        header_combine.push(
          " Transmit status: " +
            this.filtertransmitstatus(this.search.transmit_status)
        );
      }

      if (this.is_payment_status && !this.currentUser.u.is_admin) {
        header_combine.push(
          " Payment status: " + this.filterstatus(payment_status)
        );
      }
      header.push(header_combine);
      if (this.is_location_appointment) {
        header.push("Appointments");
      }
      if (this.is_location_enrollment) {
        header.push("Enrollments");
      }
      let footer = [];
      footer.push(
        "Generated at : " +
          this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      footer.push("Generated by : " + this.currentUser.u?.name);

      let data = {
        header: header,
        search: this.search,
        footer: footer,
      };
      this.header = header;
      // this.$store.dispatch(EXPORT_DATA, this.search);

      this.$emit("search", data);
    },
    filterPayment(status) {
      if (status == "P") {
        return "Paid";
      }
      if (status == "U") {
        return "Unpaid";
      }
      if (status == "all") {
        return "All";
      }
    },
    filterstatus(status) {
      if (status == "P") {
        return "Pending";
      }
      if (status == "C") {
        return "Complete";
      }
      if (status == "U") {
        return "No-show";
      }
      if (status == "Cancel") {
        return "Canceled";
      }
      if (status == "all") {
        return "All";
      }
    },
    filtertransmitstatus(status) {
      if (status == "000") {
        return "Draft";
      }
      if (status == "100") {
        return "Ready To Transmit";
      }
      if (status == "200") {
        return "Transmitted/Completed";
      }

      if (status == "all") {
        return "All";
      }
    },
    toggleSp() {
      this.spOpen = !this.spOpen;
      if (this.spOpen) {
        this.spSearch = "";
        this.$nextTick(() => {
          if (this.$refs.spInput) this.$refs.spInput.focus();
          const wrap = this.$refs.spWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.spDropStyle = { position: 'fixed', top: (r.bottom + 4) + 'px', left: r.left + 'px', width: r.width + 'px', zIndex: 9999 };
          }
        });
      }
    },
    closeSpDropdown() { this.spOpen = false; this.spSearch = ""; this.spDropStyle = {}; },
    selectSp(id) {
      this.search.sp = id;
      this.closeSpDropdown();
      this.loadSpServices();
    },
    toggleLoc() {
      this.locOpen = !this.locOpen;
      if (this.locOpen) {
        this.locSearch = "";
        this.$nextTick(() => {
          if (this.$refs.locInput) this.$refs.locInput.focus();
          const wrap = this.$refs.locWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.locDropStyle = { position: 'fixed', top: (r.bottom + 4) + 'px', left: r.left + 'px', width: r.width + 'px', zIndex: 9999 };
          }
        });
      }
    },
    closeLocDropdown() { this.locOpen = false; this.locSearch = ""; this.locDropStyle = {}; },
    selectLoc(id) {
      this.search.sp_location = id;
      this.closeLocDropdown();
      this.loadAdminServicesLocation();
    },
    toggleSpCmp() {
      this.spCmpOpen = !this.spCmpOpen;
      if (this.spCmpOpen) {
        this.spCmpSearch = "";
        this.$nextTick(() => {
          if (this.$refs.spCmpInput) this.$refs.spCmpInput.focus();
          const wrap = this.$refs.spCmpWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.spCmpDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeSpCmpDropdown() { this.spCmpOpen = false; this.spCmpSearch = ""; this.spCmpDropStyle = {}; },
    selectSpCmp(id) {
      this.search.sp = id;
      this.closeSpCmpDropdown();
      this.loadSpCompany();
    },
    toggleCmp() {
      this.cmpOpen = !this.cmpOpen;
      if (this.cmpOpen) {
        this.cmpSearch = "";
        this.$nextTick(() => {
          const input = this.$refs.cmpInput || this.$refs.cmpInput2;
          if (input) input.focus();
          const wrap = this.$refs.cmpWrap || this.$refs.cmpWrap2;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.cmpDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeCmpDropdown() { this.cmpOpen = false; this.cmpSearch = ""; this.cmpDropStyle = {}; },
    selectCmp(id) {
      this.search.company = id;
      this.closeCmpDropdown();
    },
    toggleLocIs() {
      this.locIsOpen = !this.locIsOpen;
      if (this.locIsOpen) {
        this.locIsSearch = "";
        this.$nextTick(() => {
          if (this.$refs.locIsInput) this.$refs.locIsInput.focus();
          const wrap = this.$refs.locIsWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.locIsDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeLocIsDropdown() { this.locIsOpen = false; this.locIsSearch = ""; this.locIsDropStyle = {}; },
    selectLocIs(id) {
      this.search.location = id;
      this.closeLocIsDropdown();
      this.loadServices();
    },
    loadServices() {
      this.search.service = "all";
      this.$store.dispatch(FETCH_SERVICES, this.search.location);
    },
    loadSpServices(){
      
      this.search.sp_location="all";
      this.$store.dispatch(FETCH_SERVICES_CLIENTS, this.search.sp);
      this.search.company="all";
      this.$store.dispatch(FETCH_MASTER_COMPANIES,this.search.sp)
      // if(this.is_service){
      //   //  for services inside sp
      //   this.$store.dispatch(FETCH_SERVICES, this.search.sp, this.search.sp_location);
      // }
      this.loadAdminServicesLocation()
      this.loadSpCompany()
   
    },
    loadAdminServicesLocation(){
      this.search.service="all";
     
      this.$store.dispatch(FETCH_SERVICES,{location:this.search.sp_location,sp:this.search.sp})

    },
    loadSpCompany(){
      this.search.company="all";
      this.$store.dispatch(FETCH_MASTER_COMPANIES, this.search.sp);
     
    },
    // async sleep(m) {
    //   return await setTimeout(async function() {}, m);
    // },
    setbreadcrumb() {
      let service = [...this.getServices];
      service.forEach((element) => {
        if (element.id == this.search.service) {
          this.service = element;
        }
      });
      let location = [...this.getClients];
      location.forEach((element) => {
        if (element.id == this.search.location) {
          this.location = element;
        }
      });
      let company = [...this.getMasterCompanies];
      company.forEach((element) => {
        if (element.id == this.search.company) {
          this.company = element;
        }
      });
      if (this.search.company == "all") {
        this.companyreportname = "All";
      } else {
        var company_data = company.filter(
          (item) => item.id === this.search.company
        )[0];
        this.companyreportname = company_data.company_name;
      }
      if (this.search.service == "all") {
        this.servicereportname = "All";
      } else {
        var service_data = service.filter(
          (item) => item.id === this.search.service
        )[0];

        this.servicereportname = service_data?.name;
      }
      if (this.search.location == "all") {
        this.locationreportname = "All";
      } else {
        var location_data = location.filter(
          (item) => item.id === this.search.location
        )[0];
        this.locationreportname = location_data?.name;
      }
      // header breadrump for admin reports
      if(this.search.sp =="all"){
        this.locationreportname = "All";
      }else{
         location_data = location.filter(
          (item) => item.id === this.search.sp
        )[0];
        this.locationreportname = location_data?.name;

      }
      if (this.search.search_text == "") {
        this.locationjobname = "All";
      } else {
        this.locationjobname = this.search.search_text;
      }
    },
  },
};
</script>
